var ko = require('knockout');
var ContentLibraryItemViewModel = require('./content-library-item.vm.js');

function ContentLibraryCategoryViewModel(data) {
    var self = this;
    let subcategoryItemsLoaded = false;

    self.name = ko.observable(data.name);
    self.items = ko.observable([]);
    self.disclosure = ko.observable(data.disclosure);
    self.nameSortClass = ko.observable('fa-long-arrow-up');
    self.subcategories = ko.observable([]);
    self.isDefaultCategory = ko.observable(false);

    self.totalItemCount = ko.computed(function() {
        var count = 0;

        for (var subIndex = 0; subIndex < self.subcategories().length; subIndex++) {
            count += self.subcategories()[subIndex].totalItemCount();
        }

        return count;
    }, this);

    self.hasOrderableItems = ko.computed(function () {
        return ko.utils.arrayFilter(self.items(), (item) => item.orderable()).length > 0;
    }, this);

    self.hasItemsWithFormNumber = ko.computed(function () {
        return ko.utils.arrayFilter(self.items(), (item) => item.formNumber()).length > 0;
    }, this);

    self.loadItems = function () {
        if (data.items) {
            var itemList = [];
            data.items.forEach(function (item) {
                itemList.push(new ContentLibraryItemViewModel(item));
            });

            self.items(itemList);
        }
    };

    self.loadSubcategoryItems = function () {
        if (!subcategoryItemsLoaded) {
            self.subcategories().forEach((subcategory) => subcategory.loadItems());
            subcategoryItemsLoaded = true;
        }
    };

    if (data.subcategories) {
        let subcategories = [];
        data.subcategories.forEach(function (subcategory) {
            subcategories.push(new ContentLibraryCategoryViewModel(subcategory));
        });

        self.subcategories(subcategories);
    }
}

module.exports = ContentLibraryCategoryViewModel;